// Header starts
$(document).ready(function(){
  $(".hs_header-bars, .hs_header-overlay, .hs_header-menu__cross").click(function(){
    $(".hs_header-overlay").toggleClass("active");
    $(".hs_header-menu__drawer").toggleClass("active");
    $("body").toggleClass("hs_body-hidden");
    $(".hs_header-menu__parent-js").removeClass("active");
    $(".hs_header-menu__child").slideUp(300);
    $(".hs_header-menu__child-js").removeClass("active");
    $(".hs_header-menu__grandchild").slideUp(300);
  });
});

$(document).ready(function() {
  $('.hs_header-menu__parent-js').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const $this = $(this);
    const $parentLi = $this.closest('.hs_header-menu__parent-c');
    const $childUl = $parentLi.find('.hs_header-menu__child');
    
    if ($childUl.length === 0) {
      $('.hs_header-menu__parent-js').removeClass('active');
      $this.addClass('active');
      return;
    }
    
    const isOpen = $childUl.is(':visible');
    
    $('.hs_header-menu__parent-c > .hs_header-menu__child').not($childUl).slideUp(300);
    
    $('.hs_header-menu__parent-c > a').removeClass('active');
    
    if (isOpen) {
      $childUl.slideUp(300);
      $this.removeClass('active');
    } else {
      $childUl.slideDown(300);
      $this.addClass('active');
    }
  });
  
  $('.hs_header-menu__child-js').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const $this = $(this);
    const $parentLi = $this.closest('.hs_header-menu__child-c');
    const $grandchildUl = $parentLi.find('.hs_header-menu__grandchild');
    
    if ($grandchildUl.length === 0) {
      $('.hs_header-menu__child-c > a').removeClass('active');
      $this.addClass('active');
      
      return;
    }
    
    const isOpen = $grandchildUl.is(':visible');
    
    $('.hs_header-menu__child-c > .hs_header-menu__grandchild').not($grandchildUl).slideUp(300);
    $('.hs_header-menu__child-js').removeClass('active');
    
    if (isOpen) {
      $grandchildUl.slideUp(300);
      $this.removeClass('active');
    } else {
      $grandchildUl.slideDown(300);
      $this.addClass('active');
    }
  });
  
  $('.hs_header-menu__grandchild-ca').on('click', function(e) {
    e.preventDefault();
    $('.hs_header-menu__grandchild-ca').removeClass('active');
    $(this).addClass('active');
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const cartTrigger = document.querySelector('.hs_header-cart__js');
  
  if (!cartTrigger) return;
  
  cartTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    
    const cartDrawer = document.querySelector('cart-drawer') || 
                       document.querySelector('cart-notification');
    
    if (cartDrawer) {
      if (cartDrawer.open) {
        cartDrawer.open();
      } else {
        cartDrawer.classList.toggle('active');
      }
    }
  });
});
// Header ends



// Footer starts
document.addEventListener('DOMContentLoaded', function() {
  const footerOuter = document.querySelector('.hs_footer-outer');
  const footerBg = document.querySelector('.hs_footer-bg');
  const footerI = document.querySelector('.hs_footer-i');
  
  if (!footerOuter || !footerBg || !footerI) return;
  
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        footerI.classList.add('hs_zoomed-out');
        
        observer.unobserve(footerOuter);
      }
    });
  }, { 
    threshold: 0.2
  });
  
  observer.observe(footerOuter);
  
  const contentObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        footerBg.classList.add('hs_footer-visible');
        contentObserver.unobserve(footerBg);
      }
    });
  }, { 
    threshold: 0.3
  });
  
  contentObserver.observe(footerBg);
});


$(document).ready(function() {
  function initFooterAccordion() {
    if ($(window).width() < 491) {
      $('.hs_footer-menu__heading').on('click', function(e) {
        e.preventDefault();
        
        var $this = $(this);
        var $currentMenu = $this.closest('.hs_footer-menu').find('.hs_footer-menu__menu');
        var $allMenus = $('.hs_footer-menu__menu');
        var $allHeadings = $('.hs_footer-menu__heading');
        
        if ($this.hasClass('active')) {
          $this.removeClass('active');
          $currentMenu.slideUp(300);
        } else {
          $allHeadings.removeClass('active');
          $allMenus.slideUp(300);
          
          $this.addClass('active');
          $currentMenu.slideDown(300);
        }
      });
    } else {
      $('.hs_footer-menu__menu').show();
      $('.hs_footer-menu__heading').removeClass('active');
    }
  }
  
  initFooterAccordion();
  
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      $('.hs_footer-menu__heading').off('click');
      initFooterAccordion();
    }, 250);
  });
});
// Footer ends



// Heading animation starts
document.addEventListener('DOMContentLoaded', function() {
  const headingContainers = document.querySelectorAll('.hs_heading-animate');
  
  headingContainers.forEach((container) => {
    const heading = container.querySelector('h1, h2, h3, h4, h5, h6');
    if (!heading) return;
    
    const text = heading.textContent;
    heading.textContent = '';
    
    const words = text.split(' ');
    
    words.forEach((word, wordIndex) => {
      if (wordIndex > 0) {
        const space = document.createElement('span');
        space.className = 'letter';
        space.innerHTML = '&nbsp;';
        heading.appendChild(space);
      }
      
      const wordGroup = document.createElement('span');
      wordGroup.className = 'letter-group';
      
      const chars = word.split('');
      chars.forEach((char) => {
        const span = document.createElement('span');
        span.className = 'letter';
        span.textContent = char;
        wordGroup.appendChild(span);
      });
      
      heading.appendChild(wordGroup);
    });
    
    function animateLetters() {
      const letters = heading.querySelectorAll('.letter');
      if (!letters.length) return;
      
      const rect = container.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight + 100 && rect.bottom > 0;
      
      if (isVisible) {
        letters.forEach((letter, index) => {
          setTimeout(() => {
            letter.classList.add('visible');
          }, index * 30);
        });
      } else {
        letters.forEach((letter) => {
          letter.classList.remove('visible');
        });
      }
    }
    
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        animateLetters();
      }, 50);
    });
    
    setTimeout(animateLetters, 100);
  });
});
// Heading animation ends



// Content animation starts
document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.hs_content-animate__1');
  
  containers.forEach((container) => {
    const heading = container.querySelector('h1, h2, h3, h4, h5, h6');
    if (!heading) return;
    
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      heading.style.opacity = '1';
      return;
    }
    
    const text = heading.textContent;
    heading.textContent = '';
    
    const words = text.split(' ');
    const delayMs = 180;
    
    words.forEach((word, wordIndex) => {
      const wordSpan = document.createElement('span');
      wordSpan.className = 'word';
      wordSpan.textContent = word;
      heading.appendChild(wordSpan);
      
      if (wordIndex < words.length - 1) {
        const space = document.createElement('span');
        space.textContent = ' ';
        space.style.display = 'inline-block';
        heading.appendChild(space);
      }
    });
    
    let isAnimated = false;
    
    function animateHeading() {
      const rect = container.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      const isVisible = rect.top < windowHeight - 100 && rect.bottom > 0;
      
      if (isVisible && !isAnimated) {
        isAnimated = true;
        const words = heading.querySelectorAll('.word');
        
        words.forEach((word, wordIndex) => {
          const totalDelay = delayMs * wordIndex;
          setTimeout(() => {
            word.classList.add('visible');
          }, totalDelay);
        });
      }
    }
    
    window.addEventListener('scroll', function() {
      animateHeading();
    });
    
    setTimeout(animateHeading, 100);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.hs_content-animate__2');
  
  containers.forEach((container) => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      container.style.opacity = '1';
      return;
    }
    
    const words = container.textContent.trim().split(' ');
    const delayMs = 60;
    
    const childNodes = container.childNodes;
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = container.innerHTML;
    container.innerHTML = '';
    
    words.forEach((word, wordIndex) => {
      const wordSpan = document.createElement('span');
      wordSpan.className = 'word';
      wordSpan.textContent = word;
      container.appendChild(wordSpan);
      
      if (wordIndex < words.length - 1) {
        const space = document.createElement('span');
        space.textContent = ' ';
        space.style.display = 'inline-block';
        container.appendChild(space);
      }
    });
    
    let isAnimated = false;
    
    function animateContainer() {
      const rect = container.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      const isVisible = rect.top < windowHeight - 100 && rect.bottom > 0;
      
      if (isVisible && !isAnimated) {
        isAnimated = true;
        const words = container.querySelectorAll('.word');
        
        words.forEach((word, wordIndex) => {
          const totalDelay = delayMs * wordIndex;
          setTimeout(() => {
            word.classList.add('visible');
          }, totalDelay);
        });
      }
    }
    
    window.addEventListener('scroll', function() {
      animateContainer();
    });
    
    setTimeout(animateContainer, 100);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.hs_content-animate__3');
  
  containers.forEach((container) => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      container.querySelectorAll('.child-item').forEach((item) => {
        item.classList.add('visible');
      });
      return;
    }
    
    const childItems = container.querySelectorAll(':scope > *');
    const delayMs = 150;
    
    childItems.forEach((item) => {
      item.classList.add('child-item');
    });
    
    let isAnimated = false;
    
    function animateContainer() {
      const rect = container.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      const isVisible = rect.top < windowHeight - 100 && rect.bottom > 0;
      
      if (isVisible && !isAnimated) {
        isAnimated = true;
        
        childItems.forEach((item, index) => {
          const totalDelay = delayMs * index;
          setTimeout(() => {
            item.classList.add('visible');
          }, totalDelay);
        });
      }
    }
    
    window.addEventListener('scroll', function() {
      animateContainer();
    });
    
    setTimeout(animateContainer, 100);
  });
});
// Content animation ends



// Featured collection starts
(function() {
  function initVariantSelectors() {
    const variantContainers = document.querySelectorAll('.hs_pro-inner__variants');
    
    if (variantContainers.length === 0) return;
    
    variantContainers.forEach(function(variantContainer) {
      const productContainer = variantContainer.closest('.hs_pro');
      if (!productContainer) return;
      
      const radioButtons = variantContainer.querySelectorAll('.hs_pro-inner__variant-input');
      if (radioButtons.length === 0) return;
      
      const atcButton = productContainer.querySelector('.hs_pro-atc');
      if (!atcButton) return;
      
      const priceElement = productContainer.querySelector('.hs_pro-price__js');
      const comparePriceElement = productContainer.querySelector('.hs_pro-cprice__js');
      const originalButtonText = atcButton.textContent;
      
      function updateProductInfo(selectedRadio) {
        if (!selectedRadio) return;
        
        const variantId = selectedRadio.value;
        const price = selectedRadio.getAttribute('data-price');
        const comparePrice = selectedRadio.getAttribute('data-compare-price');
        const inventory = selectedRadio.getAttribute('data-inventory');
        
        atcButton.setAttribute('data-variant-id', variantId);
        
        if (priceElement && price) {
          priceElement.textContent = price;
        }
        
        if (comparePriceElement) {
          if (comparePrice && comparePrice !== '0.00' && comparePrice !== '$0.00') {
            comparePriceElement.textContent = comparePrice;
            comparePriceElement.style.display = 'inline';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }
        
        const inventoryNum = parseInt(inventory);
        const isAvailable = isNaN(inventoryNum) || inventoryNum > 0;
        
        if (isAvailable) {
          if (atcButton.classList.contains('sold-out')) {
            atcButton.classList.remove('sold-out');
            atcButton.disabled = false;
          }
          atcButton.textContent = originalButtonText;
        } else {
          atcButton.classList.add('sold-out');
          atcButton.disabled = true;
          atcButton.textContent = 'Sold Out';
        }
      }
      
      radioButtons.forEach(function(radio) {
        radio.addEventListener('change', function() {
          if (this.checked) {
            updateProductInfo(this);
          }
        });
      });
      
      const firstAvailableRadio = variantContainer.querySelector('.hs_pro-inner__variant-input');
      if (firstAvailableRadio) {
        firstAvailableRadio.checked = true;
        updateProductInfo(firstAvailableRadio);
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if (document.querySelector('.hs_pro-inner__variants')) {
        initVariantSelectors();
      }
    });
  } else {
    if (document.querySelector('.hs_pro-inner__variants')) {
      initVariantSelectors();
    }
  }
  
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail && event.detail.sectionId) {
      setTimeout(function() {
        if (document.querySelector('.hs_pro-inner__variants')) {
          initVariantSelectors();
        }
      }, 100);
    }
  });
  
  window.featuredCollectionATC = {
    isAdding: false,
    
    addToCart: async function(variantId, buttonElement) {
      if (this.isAdding) return;
      
      this.isAdding = true;
      const originalBtnText = buttonElement.textContent;
      
      buttonElement.textContent = 'Adding...';
      buttonElement.disabled = true;
      
      try {
        const cartDrawerElement = document.querySelector('cart-drawer');
        
        const formDataObject = new FormData();
        formDataObject.append('id', variantId);
        formDataObject.append('quantity', 1);
        
        if (cartDrawerElement) {
          const sectionsArray = cartDrawerElement.getSectionsToRender().map(section => section.id);
          formDataObject.append('sections', sectionsArray.join(','));
          formDataObject.append('sections_url', window.location.pathname);
          cartDrawerElement.setActiveElement(document.activeElement);
        }
        
        const fetchResponse = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formDataObject
        });
        
        const responseData = await fetchResponse.json();
        
        if (responseData.status) {
          buttonElement.textContent = 'Error!';
          setTimeout(() => {
            buttonElement.textContent = originalBtnText;
            buttonElement.disabled = false;
            window.featuredCollectionATC.isAdding = false;
          }, 2000);
          return;
        }
        
        if (cartDrawerElement) {
          if (typeof cartDrawerElement.renderContents === 'function') {
            cartDrawerElement.renderContents(responseData);
          } else {
            await updateCartDrawerContent(cartDrawerElement);
          }
        }
        
        await updateCartCount();
        await updateCartDrawerItems();
        
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'featured-collection',
            productVariantId: variantId,
            cartData: responseData
          });
        }
        
        buttonElement.textContent = 'Added!';
        setTimeout(() => {
          buttonElement.textContent = originalBtnText;
          buttonElement.disabled = false;
          window.featuredCollectionATC.isAdding = false;
        }, 2000);
        
      } catch (error) {
        buttonElement.textContent = originalBtnText;
        buttonElement.disabled = false;
        window.featuredCollectionATC.isAdding = false;
      }
    }
  };
  
  async function updateCartCount() {
    try {
      const cartDataResponse = await fetch('/cart.js');
      const cartData = await cartDataResponse.json();
      
      const countElements = document.querySelectorAll('.hs_header-cart__count, .cart-count-bubble');
      countElements.forEach(element => {
        if (element) element.textContent = cartData.item_count;
      });
      
      const cartDrawerWrapper = document.querySelector('.hs_cart-drawer, .pe_cart-drawer, cart-drawer');
      if (cartDrawerWrapper) {
        if (cartData.item_count > 0) {
          cartDrawerWrapper.classList.remove('is-empty');
        } else {
          cartDrawerWrapper.classList.add('is-empty');
        }
      }
    } catch (error) {}
  }
  
  async function updateCartDrawerContent(cartDrawerElement) {
    try {
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      const cartItemsContainer = cartDrawerElement.querySelector('.cart-items, .cart-drawer__items, [data-cart-items]');
      if (cartItemsContainer) {
        const sectionId = cartDrawerElement.dataset.section || 'cart-drawer';
        const sectionUrl = `/sections/${sectionId}`;
        
        const sectionResponse = await fetch(sectionUrl);
        const sectionHtml = await sectionResponse.text();
        
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sectionHtml;
        
        const newItems = tempDiv.querySelector('.cart-items, .cart-drawer__items, [data-cart-items]');
        if (newItems) {
          cartItemsContainer.innerHTML = newItems.innerHTML;
        }
        
        const cartFooter = cartDrawerElement.querySelector('.cart-drawer__footer, .cart-footer');
        const newFooter = tempDiv.querySelector('.cart-drawer__footer, .cart-footer');
        if (cartFooter && newFooter) {
          cartFooter.innerHTML = newFooter.innerHTML;
        }
      }
      
      const totalElements = cartDrawerElement.querySelectorAll('.cart-total, .cart__total, .total-price');
      totalElements.forEach(element => {
        if (cartData.total_price) {
          element.textContent = formatMoney(cartData.total_price);
        }
      });
      
    } catch (error) {}
  }
  
  async function updateCartDrawerItems() {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      
      const sectionId = cartDrawer.dataset.section || 'cart-drawer';
      const sectionUrl = `/sections/${sectionId}`;
      
      const response = await fetch(sectionUrl);
      const html = await response.text();
      
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      const itemsContainer = cartDrawer.querySelector('.cart-items, .cart-drawer__items, [data-cart-items]');
      const newItemsContainer = tempDiv.querySelector('.cart-items, .cart-drawer__items, [data-cart-items]');
      if (itemsContainer && newItemsContainer) {
        itemsContainer.innerHTML = newItemsContainer.innerHTML;
      }
      
      const footer = cartDrawer.querySelector('.cart-drawer__footer, .cart-footer');
      const newFooter = tempDiv.querySelector('.cart-drawer__footer, .cart-footer');
      if (footer && newFooter) {
        footer.innerHTML = newFooter.innerHTML;
      }
      
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      
      const totalElements = cartDrawer.querySelectorAll('.cart-total, .cart__total, .total-price');
      totalElements.forEach(element => {
        if (cartData.total_price) {
          element.textContent = formatMoney(cartData.total_price);
        }
      });
      
    } catch (error) {}
  }
  
  function formatMoney(amount) {
    return '$' + (amount / 100).toFixed(2);
  }
  
  document.addEventListener('click', function(event) {
    const targetButton = event.target.closest('.hs_pro-atc');
    
    if (targetButton) {
      if (targetButton.classList.contains('sold-out') || targetButton.disabled) {
        event.preventDefault();
        return;
      }
      
      if (window.featuredCollectionATC.isAdding) {
        event.preventDefault();
        return;
      }
      
      event.preventDefault();
      event.stopPropagation();
      
      const variantIdValue = targetButton.getAttribute('data-variant-id');
      
      if (variantIdValue) {
        window.featuredCollectionATC.addToCart(variantIdValue, targetButton);
      }
    }
  });
  
  if (!window.routes) {
    window.routes = {};
  }
  if (!window.routes.cart_add_url) {
    window.routes.cart_add_url = '/cart/add';
  }
})();
// Featured collection ends



// Faqs starts
$(document).ready(function() {
  $('.hs_faqs-faq__header').on('click', function() {
    var $this = $(this);
    var $faq = $this.closest('.hs_faqs-faq');
    var $body = $faq.find('.hs_faqs-faq__body');
    
    if ($faq.hasClass('active')) {
      $faq.removeClass('active');
      $body.slideUp(200);
    } else {
      $('.hs_faqs-faq').each(function() {
        $(this).removeClass('active');
        $(this).find('.hs_faqs-faq__body').slideUp(200);
      });
      
      $faq.addClass('active');
      $body.slideDown(200);
    }
  });
});
// Faqs ends



// Testimonials strats
document.addEventListener('DOMContentLoaded', function() {
  var splide = new Splide('.hs_testimonials-reviews', {
    type: 'loop',
    perPage: 4,
    gap: '40px',
    arrows: false,
    pagination: false,
    autoScroll: {
      speed: 0.5,
      pauseOnHover: true,
      pauseOnFocus: false,
      rewind: false,
    },
    rewind: false,
    breakpoints: {
      1440: {
        perPage: 3,
        gap: '35px',
      },
      768: {
        perPage: 2,
        gap: '30px',
      },
      490: {
        perPage: 1,
        gap: '25px',
      }
    }
  });
  
  splide.mount(window.splide.Extensions);
});
// Testimonials ends



// Main product starts
document.addEventListener('DOMContentLoaded', function() {
  if (typeof Swiper !== 'undefined') {
    var thumbSwiper = new Swiper('.hs_main_product-gallery__thumbnails', {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 7,
      freeMode: false,
      watchSlidesProgress: true,
      direction: 'horizontal',
      breakpoints: {
        491: {
          direction: 'horizontal',
          slidesPerView: 4,
          spaceBetween: 7,
        },
        769: {
          direction: 'horizontal',
          slidesPerView: 4,
          spaceBetween: 7,
        },
        1025: {
          direction: 'horizontal',
          slidesPerView: 5,
          spaceBetween: 7,
        },
        1271: {
          direction: 'vertical',
          slidesPerView: 5,
          spaceBetween: 7,
        }
      }
    });

    var mainSwiper = new Swiper('.hs_main_product-gallery__main', {
      loop: true,
      spaceBetween: 0,
      pagination: {
        el: '.hs_main_product-gallery__pagination',
        clickable: true,
        dynamicBullets: false,
      },
      thumbs: {
        swiper: thumbSwiper,
      },
      navigation: false,
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const videos_videos = new Swiper('.hs_main_product-videos__videos', {
    slidesPerView: 1.6,
    spaceBetween: 10,
    breakpoints: {
      375: {
        slidesPerView: 2.1,
        spaceBetween: 10,
      },
      491: {
        slidesPerView: 2.6,
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: '.hs_main_product-videos__next',
      prevEl: '.hs_main_product-videos__prev',
    },
    on: {
      slideChange: function() {
        document.querySelectorAll('.hs_main_product-videos__video video').forEach(function(video) {
          if (!video.paused) {
            video.pause();
            const playIcon = video.closest('.hs_main_product-videos__video').querySelector('.hs_main_product-videos__play');
            if (playIcon) {
              playIcon.style.display = 'flex';
            }
          }
        });
      }
    }
  });

  document.querySelectorAll('.hs_main_product-videos__video').forEach(function(videoContainer) {
    const video = videoContainer.querySelector('video');
    const playIcon = videoContainer.querySelector('.hs_main_product-videos__play');
    
    if (video && playIcon) {
      videoContainer.addEventListener('click', function(e) {
        if (e.target.closest('.hs_main_product-videos__arrow')) {
          return;
        }
        
        toggleVideo(video, playIcon);
      });
    }
  });

  function toggleVideo(video, playIcon) {
    if (video.paused) {
      document.querySelectorAll('.hs_main_product-videos__video video').forEach(function(otherVideo) {
        if (otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
          const otherPlayIcon = otherVideo.closest('.hs_main_product-videos__video').querySelector('.hs_main_product-videos__play');
          if (otherPlayIcon) {
            otherPlayIcon.style.display = 'flex';
          }
        }
      });
      
      video.play();
      playIcon.style.display = 'none';
    } else {
      video.pause();
      playIcon.style.display = 'flex';
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  function setupAccordions() {
    document.querySelectorAll('.hs_main_product-details').forEach(function(details) {
      const summary = details.querySelector('summary') || details.querySelector('.hs_main_product-summary');
      if (!summary) return;
      
      const newSummary = summary.cloneNode(true);
      summary.parentNode.replaceChild(newSummary, summary);
      
      newSummary.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const currentDetails = this.closest('.hs_main_product-details');
        if (!currentDetails) return;
        
        if (currentDetails.classList.contains('active')) {
          currentDetails.classList.remove('active');
          if (currentDetails.hasAttribute('open')) {
            currentDetails.removeAttribute('open');
          }
          return;
        }
        
        document.querySelectorAll('.hs_main_product-details').forEach(function(d) {
          d.classList.remove('active');
          if (d.hasAttribute('open')) {
            d.removeAttribute('open');
          }
        });
        
        currentDetails.classList.add('active');
        if (currentDetails.tagName === 'DETAILS') {
          currentDetails.setAttribute('open', '');
        }
      });
    });
  }
  
  setupAccordions();
  
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(setupAccordions, 300);
    });
  }
  
  setTimeout(setupAccordions, 2000);
  setTimeout(setupAccordions, 3000);
});
// Main product ends



// Sticky ATC starts
document.addEventListener('DOMContentLoaded', function() {
  const stickyATC = document.querySelector('.hs_sticky_atc-bg');
  const productFormSubmit = document.querySelector('.hs_main_product .product-form__submit');
  
  if (!stickyATC || !productFormSubmit) return;
  
  function checkButtonPosition() {
    const rect = productFormSubmit.getBoundingClientRect();
    const threshold = 0;
    
    if (rect.top <= threshold) {
      stickyATC.classList.add('hs_visible');
    } else {
      stickyATC.classList.remove('hs_visible');
    }
  }
  
  window.addEventListener('scroll', checkButtonPosition);
  
  window.addEventListener('resize', checkButtonPosition);
  
  checkButtonPosition();
});


document.addEventListener('DOMContentLoaded', function() {
  const variantDisplay = document.querySelector('.hs_sticky_atc-variant');
  const variantInputs = document.querySelectorAll('.hs_main_product-input');
  const stickyButton = document.querySelector('.hs_sticky_atc-button__js');
  
  if (!variantDisplay || variantInputs.length === 0) return;
  
  variantDisplay.textContent = '';
  
  let originalButtonText = '';
  if (stickyButton) {
    originalButtonText = stickyButton.textContent.trim();
  }
  
  function updateVariantText() {
    const selectedValues = [];
    let isDisabled = false;
    
    variantInputs.forEach(input => {
      if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        if (selectedOption && selectedOption.text !== 'Choose an option' && selectedOption.text !== '-') {
          selectedValues.push(selectedOption.text);
        }
        if (input.classList.contains('disabled')) {
          isDisabled = true;
        }
      } else if (input.type === 'radio' && input.checked) {
        selectedValues.push(input.value);
        if (input.classList.contains('disabled')) {
          isDisabled = true;
        }
      } else if (input.type === 'text' || input.type === 'number') {
        if (input.value) {
          selectedValues.push(input.value);
        }
        if (input.classList.contains('disabled')) {
          isDisabled = true;
        }
      }
    });
    
    variantDisplay.textContent = selectedValues.length > 0 ? selectedValues.join(' - ') : '';
    
    if (stickyButton) {
      if (isDisabled) {
        stickyButton.classList.add('disabled');
        stickyButton.disabled = true;
        stickyButton.textContent = 'Sold out';
      } else {
        stickyButton.classList.remove('disabled');
        stickyButton.disabled = false;
        stickyButton.textContent = originalButtonText;
      }
    }
  }
  
  updateVariantText();
  
  variantInputs.forEach(input => {
    input.addEventListener('change', updateVariantText);
    if (input.type === 'text' || input.type === 'number') {
      input.addEventListener('input', updateVariantText);
    }
  });
  
  document.querySelectorAll('.hs_main_product-input[type="radio"]').forEach(radio => {
    radio.addEventListener('click', updateVariantText);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const stickyButton = document.querySelector('.hs_sticky_atc-button__js');
  const mainSubmitButton = document.querySelector('.hs_main_product .product-form__submit');
  
  if (stickyButton && mainSubmitButton) {
    stickyButton.addEventListener('click', function(e) {
      e.preventDefault();
      mainSubmitButton.click();
    });
  }
});
// Sticky ATC ends



// Videos strats
document.addEventListener('DOMContentLoaded', function() {
  const videoSlider = new Swiper('.hs_videos-videos.swiper', {
    loop: true,
    slidesPerView: 1.4,
    spaceBetween: 15,
    centeredSlides: false,
    pagination: {
      el: '.hs_videos-pagination',
      clickable: true,
    },
    breakpoints: {
      491: {
        slidesPerView: 1.8,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 25,
      },
      1025: {
        slidesPerView: 2.8,
        spaceBetween: 30,
      },
      1441: {
        slidesPerView: 3.2,
        spaceBetween: 30,
      }
    },
  });
});
// Videos ends



// Blog starts
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.hs_blog-button__js');
  const contents = document.querySelectorAll('.hs_blog-data');
  const heading = document.querySelector('.hs_blog-heading__js');

  if (!buttons.length) return;

  function switchTab(button) {
    const tabId = button.getAttribute('data-id');
    const buttonText = button.textContent;

    if (heading) heading.textContent = buttonText;

    contents.forEach(content => {
      if (content.getAttribute('data-tab') === tabId) {
        content.style.display = 'block';
        content.classList.add('active');
      } else {
        content.style.display = 'none';
        content.classList.remove('active');
      }
    });

    buttons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
  }

  const firstButton = buttons[0];
  if (firstButton) {
    firstButton.classList.add('active');
    switchTab(firstButton);
  }

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      if (this.classList.contains('active')) return;
      switchTab(this);
    });
  });
});
// Blog ends



// Comparison starts
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.hs_comparison-slides');
  if (!container) return;
  
  const slides = container.querySelectorAll('.hs_comparison-slide');
  if (slides.length === 0) return;
  
  slides.forEach(function(slide) {
    slide.classList.remove('active');
    slide.style.display = 'none';
  });
  
  slides[0].classList.add('active');
  slides[0].style.display = 'block';
  
  let currentIndex = 0;
  
  const cursorImage = container.dataset.cursorImage;
  if (cursorImage) {
    const customCursor = document.createElement('div');
    customCursor.style.cssText = `
      position: fixed;
      pointer-events: none;
      z-index: 9999;
      width: 100px;
      height: 100px;
      background-image: url('${cursorImage}');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      transform: translate(-50%, -50%);
      display: none;
    `;
    document.body.appendChild(customCursor);
    
    container.addEventListener('mouseenter', function(e) {
      customCursor.style.display = 'block';
      customCursor.style.left = e.clientX + 'px';
      customCursor.style.top = e.clientY + 'px';
    });
    
    container.addEventListener('mousemove', function(e) {
      customCursor.style.left = e.clientX + 'px';
      customCursor.style.top = e.clientY + 'px';
    });
    
    container.addEventListener('mouseleave', function() {
      customCursor.style.display = 'none';
    });
  }
  
  container.addEventListener('click', function(e) {
    if (e.target.closest('.hs_comparison-button__js')) return;
    
    const offsetX = -15;
    const offsetY = -30;
    createSpray(e.clientX + offsetX, e.clientY + offsetY);
    
    slides[currentIndex].classList.remove('active');
    slides[currentIndex].style.display = 'none';
    
    currentIndex = (currentIndex + 1) % slides.length;
    
    slides[currentIndex].classList.add('active');
    slides[currentIndex].style.display = 'block';
  });
  
  function createSpray(x, y) {
    const particleCount = 120;
    const sprayAngle = Math.PI;
    const spraySpread = Math.PI / 2.5;
    
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'sprinkle-particle';
      
      const size = Math.random() * 8 + 2;
      const angle = sprayAngle + (Math.random() - 0.5) * spraySpread;
      const distance = Math.random() * 250 + 20;
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance * 0.6;
      
      const shapes = ['50%', '30%', '20%', '10%', '40%'];
      const shape = shapes[Math.floor(Math.random() * shapes.length)];
      
      particle.style.cssText = `
        position: fixed !important;
        left: ${x - size/2}px !important;
        top: ${y - size/2}px !important;
        width: ${size}px !important;
        height: ${size * (Math.random() * 0.5 + 0.75)}px !important;
        background: #ffffff !important;
        border-radius: ${shape} !important;
        pointer-events: none !important;
        z-index: 99999999 !important;
        opacity: ${Math.random() * 0.8 + 0.2} !important;
        box-shadow: 0 0 ${Math.random() * 10 + 2}px rgba(255,255,255,0.5) !important;
        transition: all ${0.5 + Math.random() * 0.4}s cubic-bezier(0.22, 1, 0.36, 1) !important;
      `;
      
      document.body.appendChild(particle);
      
      setTimeout(function() {
        particle.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(0) rotate(' + (Math.random() * 360) + 'deg)';
        particle.style.opacity = '0';
      }, Math.random() * 30);
      
      setTimeout(function() {
        if (particle.parentNode) {
          particle.remove();
        }
      }, 1500);
    }
  }
  
  const button = document.querySelector('.hs_comparison-button__js');
  if (button) {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      
      slides.forEach(function(slide) {
        slide.classList.remove('active');
        slide.style.display = 'none';
      });
      
      currentIndex = 0;
      slides[0].classList.add('active');
      slides[0].style.display = 'block';
    });
  }
});
// Comparison ends



// Reviews starts
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.hs_reviews-review__button-js');
  
  buttons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      var parentReview = this.closest('.hs_reviews-review');
      
      if (parentReview.classList.contains('active')) {
        parentReview.classList.remove('active');
        document.querySelectorAll('.hs_reviews-review.nonactive').forEach(function(review) {
          review.classList.remove('nonactive');
        });
      } else {
        document.querySelectorAll('.hs_reviews-review.active').forEach(function(review) {
          review.classList.remove('active');
        });
        
        document.querySelectorAll('.hs_reviews-review.nonactive').forEach(function(review) {
          review.classList.remove('nonactive');
        });
        
        document.querySelectorAll('.hs_reviews-review').forEach(function(review) {
          if (review !== parentReview) {
            review.classList.add('nonactive');
          }
        });
        
        parentReview.classList.add('active');
      }
    });
  });
});
// Reviews ends



// Boards starts
document.addEventListener('DOMContentLoaded', function() {
  const heading = document.querySelector('.hs_boards-heading h3');
  if (!heading) return;
  
  function wrapLetters() {
    const text = heading.textContent;
    heading.textContent = '';
    
    const chars = text.split('');
    
    chars.forEach((char) => {
      const span = document.createElement('span');
      span.className = 'letter';
      
      if (char === ' ') {
        span.innerHTML = '&nbsp;';
      } else {
        span.textContent = char;
      }
      
      heading.appendChild(span);
    });
  }
  
  function animateLetters() {
    const letters = heading.querySelectorAll('.letter');
    if (!letters.length) return;
    
    const rect = heading.closest('.hs_boards-heading').getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight + 100 && rect.bottom > 0;
    
    if (isVisible) {
      letters.forEach((letter, index) => {
        setTimeout(() => {
          letter.classList.add('visible');
        }, index * 30);
      });
    } else {
      letters.forEach((letter) => {
        letter.classList.remove('visible');
      });
    }
  }
  
  wrapLetters();
  
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      animateLetters();
    }, 50);
  });
  
  setTimeout(animateLetters, 100);
});


$(document).ready(function() {
  function animateNumber(element, targetNumber) {
    var $element = $(element);
    var currentNumber = 0;
    var duration = 2000;
    var stepTime = 20;
    var steps = duration / stepTime;
    var increment = targetNumber / steps;
    
    var timer = setInterval(function() {
      currentNumber += increment;
      if (currentNumber >= targetNumber) {
        $element.text(Math.round(targetNumber));
        clearInterval(timer);
      } else {
        $element.text(Math.floor(currentNumber));
      }
    }, stepTime);
  }
  
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var $countSpan = $(entry.target);
        if (!$countSpan.hasClass('animated')) {
          $countSpan.addClass('animated');
          var targetNumber = parseFloat($countSpan.data('target'));
          animateNumber(entry.target, targetNumber);
        }
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  
  $('.hs_boards-board__count').each(function() {
    observer.observe(this);
  });
});
// Boards ends



// Heading content starts
document.addEventListener('DOMContentLoaded', function() {
  const heading = document.querySelector('.hs_heading_content-heading h3');
  if (!heading) return;
  
  function wrapLetters() {
    const text = heading.textContent;
    heading.textContent = '';
    
    const chars = text.split('');
    
    chars.forEach((char) => {
      const span = document.createElement('span');
      span.className = 'letter';
      
      if (char === ' ') {
        span.innerHTML = '&nbsp;';
      } else {
        span.textContent = char;
      }
      
      heading.appendChild(span);
    });
  }
  
  function animateLetters() {
    const letters = heading.querySelectorAll('.letter');
    if (!letters.length) return;
    
    const rect = heading.closest('.hs_heading_content-heading').getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight - 100 && rect.bottom > 0;
    
    if (isVisible) {
      letters.forEach((letter, index) => {
        setTimeout(() => {
          letter.classList.add('visible');
        }, index * 30);
      });
    } else {
      letters.forEach((letter) => {
        letter.classList.remove('visible');
      });
    }
  }
  
  wrapLetters();
  
  window.addEventListener('scroll', function() {
    animateLetters();
  });
  
  setTimeout(animateLetters, 100);
});


$(document).ready(function(){
  let heading_content_slider;
  heading_content_slider = new Swiper(".hs_heading_content-boxes", {
    zoom: false,
    loop: true,
    slidesPerView: 1.4,
    centeredSlides: false,
    spaceBetween: 20,
    autoHeight: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    breakpoints: {
      2001: {
        slidesPerView: 7.5,
      },
      1701: {
        slidesPerView: 6.3,
      },
      1441: {
        slidesPerView: 5.2,
      },
      1025: {
        slidesPerView: 4.3,
      },
      769: {
        slidesPerView: 3.4,
      },
      491: {
        slidesPerView: 2.5,
      }
    },
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.hs_heading_content-box');
  
  function isDesktop() {
    return window.innerWidth >= 1025;
  }
  
  function applyAnimation() {
    if (!isDesktop()) {
      cards.forEach((card) => {
        card.style.transform = '';
        card.style.zIndex = '';
        card.dataset.initialRotate = '';
        card.dataset.initialX = '';
        card.dataset.initialY = '';
      });
      return;
    }
    
    cards.forEach((card) => {
      const randomRotate = (Math.random() * 8) - 4;
      const randomX = (Math.random() * 6) - 3;
      const randomY = (Math.random() * 6) - 3;
      
      card.dataset.initialRotate = randomRotate;
      card.dataset.initialX = randomX;
      card.dataset.initialY = randomY;
      
      card.style.transform = `translate(${randomX}px, ${randomY}px) rotate(${randomRotate}deg)`;
    });
    
    cards.forEach((card) => {
      card.removeEventListener('mouseenter', handleMouseEnter);
      card.removeEventListener('mouseleave', handleMouseLeave);
      
      card.addEventListener('mouseenter', handleMouseEnter);
      card.addEventListener('mouseleave', handleMouseLeave);
    });
  }
  
  function handleMouseEnter(e) {
    const card = e.currentTarget;
    if (!isDesktop()) return;
    
    const newRotate = (Math.random() * 10) - 5;
    const newX = (Math.random() * 10) - 5;
    const newY = (Math.random() * 10) - 5;
    
    card.style.transform = `translate(${newX}px, ${newY}px) rotate(${newRotate}deg) scale(1.08)`;
    card.style.zIndex = '5';
    
    cards.forEach((other) => {
      if (other !== card) {
        const pushX = (Math.random() * 100) - 50;
        const pushY = (Math.random() * 100) - 50;
        const pushRotate = (Math.random() * 15) - 7.5;
        
        other.style.transform = `translate(${pushX}px, ${pushY}px) rotate(${pushRotate}deg)`;
      }
    });
  }
  
  function handleMouseLeave(e) {
    const card = e.currentTarget;
    if (!isDesktop()) return;
    
    cards.forEach((reset) => {
      const x = parseFloat(reset.dataset.initialX) || 0;
      const y = parseFloat(reset.dataset.initialY) || 0;
      const rotate = parseFloat(reset.dataset.initialRotate) || 0;
      
      reset.style.transform = `translate(${x}px, ${y}px) rotate(${rotate}deg) scale(1)`;
      reset.style.zIndex = '1';
    });
  }
  
  applyAnimation();
  
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      applyAnimation();
    }, 250);
  });
});
// Heading content ends



// Reviews starts
document.addEventListener('DOMContentLoaded', function() {
  const heading = document.querySelector('.hs_reviews-info h3');
  if (!heading) return;
  
  function wrapLetters() {
    const text = heading.textContent;
    heading.textContent = '';
    
    const chars = text.split('');
    
    chars.forEach((char) => {
      const span = document.createElement('span');
      span.className = 'letter';
      
      if (char === ' ') {
        span.innerHTML = '&nbsp;';
      } else {
        span.textContent = char;
      }
      
      heading.appendChild(span);
    });
  }
  
  function animateLetters() {
    const letters = heading.querySelectorAll('.letter');
    if (!letters.length) return;
    
    const rect = heading.closest('.hs_reviews-info').getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight + 100 && rect.bottom > 0;
    
    if (isVisible) {
      letters.forEach((letter, index) => {
        setTimeout(() => {
          letter.classList.add('visible');
        }, index * 30);
      });
    } else {
      letters.forEach((letter) => {
        letter.classList.remove('visible');
      });
    }
  }
  
  wrapLetters();
  
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      animateLetters();
    }, 50);
  });
  
  setTimeout(animateLetters, 100);
});
// Reviews ends



// Newsletter starts
document.addEventListener('DOMContentLoaded', function() {
  const heading = document.querySelector('.pe_newsletter-heading h3');
  if (!heading) return;
  
  function wrapLetters() {
    const text = heading.textContent;
    heading.textContent = '';
    
    const chars = text.split('');
    
    chars.forEach((char) => {
      const span = document.createElement('span');
      span.className = 'letter';
      
      if (char === ' ') {
        span.innerHTML = '&nbsp;';
      } else {
        span.textContent = char;
      }
      
      heading.appendChild(span);
    });
  }
  
  function animateLetters() {
    const letters = heading.querySelectorAll('.letter');
    if (!letters.length) return;
    
    const rect = heading.closest('.pe_newsletter-heading').getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight + 100 && rect.bottom > 0;
    
    if (isVisible) {
      letters.forEach((letter, index) => {
        setTimeout(() => {
          letter.classList.add('visible');
        }, index * 30);
      });
    } else {
      letters.forEach((letter) => {
        letter.classList.remove('visible');
      });
    }
  }
  
  wrapLetters();
  
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      animateLetters();
    }, 50);
  });
  
  setTimeout(animateLetters, 100);
});
// Newsletter ends



// Banner starts
document.addEventListener('DOMContentLoaded', function() {
  const image = document.querySelector('.hs_banner-info__image');
  
  if (!image) return;
  
  // Check screen width ranges
  function isExtraLarge2() {
    return window.innerWidth >= 1601;
  }
  
  function isExtraLarge() {
    return window.innerWidth >= 1441 && window.innerWidth <= 1600;
  }
  
  function isLargeDesktop() {
    return window.innerWidth >= 1271 && window.innerWidth <= 1440;
  }
  
  function isMediumLarge() {
    return window.innerWidth >= 1120 && window.innerWidth <= 1200;
  }
  
  function isMediumDesktop() {
    return window.innerWidth >= 1201 && window.innerWidth <= 1270;
  }
  
  function isMediumSmall() {
    return window.innerWidth >= 1025 && window.innerWidth <= 1119;
  }
  
  function isTablet() {
    return window.innerWidth >= 769 && window.innerWidth <= 1024;
  }
  
  function isMobile() {
    return window.innerWidth >= 701 && window.innerWidth <= 768;
  }
  
  function isSmallMobile() {
    return window.innerWidth >= 631 && window.innerWidth <= 700;
  }
  
  function isExtraSmallMobile() {
    return window.innerWidth >= 491 && window.innerWidth <= 630;
  }
  
  function isTinyMobile() {
    return window.innerWidth >= 426 && window.innerWidth <= 490;
  }
  
  function isVeryTinyMobile() {
    return window.innerWidth >= 376 && window.innerWidth <= 425;
  }
  
  function isSuperTinyMobile() {
    return window.innerWidth <= 375;
  }
  
  // Get the appropriate start top based on screen size
  function getStartTop() {
    if (isMediumLarge()) {
      return 27;
    }
    if (isMediumSmall()) {
      return 29;
    }
    if (isTablet()) {
      return 31;
    }
    if (isMobile() || isSmallMobile() || isExtraSmallMobile() || isTinyMobile() || isVeryTinyMobile() || isSuperTinyMobile()) {
      return 35;
    }
    return 25;
  }
  
  // Get the appropriate start left based on screen size
  function getStartLeft() {
    if (isSuperTinyMobile()) {
      return 37;
    }
    if (isVeryTinyMobile()) {
      return 38;
    }
    if (isTinyMobile()) {
      return 40;
    }
    if (isExtraSmallMobile()) {
      return 42;
    }
    if (isSmallMobile()) {
      return 43;
    }
    if (isMobile()) {
      return 44;
    }
    return 44;
  }
  
  // Get the appropriate end left based on screen size
  function getEndLeft() {
    if (isSuperTinyMobile() || isVeryTinyMobile() || isTinyMobile()) {
      return 50;
    }
    return 44;
  }
  
  // Get the appropriate start width based on screen size
  function getStartWidth() {
    if (isSuperTinyMobile()) {
      return 21;
    }
    if (isVeryTinyMobile()) {
      return 18;
    }
    if (isTinyMobile()) {
      return 15;
    }
    return 9;
  }
  
  // Get the appropriate end width based on screen size
  function getEndWidth() {
    if (isSuperTinyMobile()) {
      return 40;
    }
    if (isVeryTinyMobile()) {
      return 35;
    }
    if (isTinyMobile()) {
      return 30;
    }
    if (isMobile() || isSmallMobile() || isExtraSmallMobile()) {
      return 25;
    }
    return 15;
  }
  
  // Get the appropriate end top based on screen size
  function getEndTop() {
    // Mobile (768 and below) - restored to original values
    if (isSuperTinyMobile()) {
      return 113;
    }
    if (isVeryTinyMobile()) {
      return 115;
    }
    if (isTinyMobile()) {
      return 120;
    }
    if (isMobile() || isSmallMobile() || isExtraSmallMobile()) {
      return 130;
    }
    
    // Tablet (769-1024)
    if (isTablet()) {
      return 120; // 130 - 10
    }
    
    // Desktop 1025-1119
    if (isMediumSmall()) {
      return 140; // 150 - 10
    }
    
    // Desktop 1120-1200
    if (isMediumLarge()) {
      return 140; // 150 - 10
    }
    
    // Desktop 1201-1270
    if (isMediumDesktop()) {
      return 135; // 145 - 10
    }
    
    // Large Desktop 1271-1440
    if (isLargeDesktop()) {
      return 160; // 170 - 10
    }
    
    // Extra Large 1441-1600
    if (isExtraLarge()) {
      return 150; // 160 - 10
    }
    
    // Extra Large 2 (1601+)
    if (isExtraLarge2()) {
      return 140; // 150 - 10
    }
    
    return 150; // Default fallback
  }
  
  // Set initial state
  function setStartState() {
    const startTop = getStartTop();
    const startLeft = getStartLeft();
    const startWidth = getStartWidth();
    image.style.top = startTop + 'vh';
    image.style.left = startLeft + '%';
    image.style.width = startWidth + '%';
    image.style.transform = 'translateX(-50%) rotate(25deg)';
    image.style.bottom = 'auto';
  }
  
  // Set desktop state (when animation is complete)
  function setDesktopState() {
    image.style.top = '150vh';
    image.style.left = '31%';
    image.style.width = '15%';
    image.style.transform = 'translateX(-50%) rotate(0deg)';
    image.style.bottom = 'auto';
  }
  
  // Apply appropriate state based on screen width
  function applyState() {
    if (isMobile() || isSmallMobile() || isExtraSmallMobile() || isTinyMobile() || isVeryTinyMobile() || isSuperTinyMobile()) {
      setStartState();
      return;
    }
    if (isLargeDesktop() || isMediumDesktop() || isMediumLarge() || isMediumSmall() || isTablet() || isExtraLarge() || isExtraLarge2()) {
      setStartState();
    } else {
      setDesktopState();
    }
  }
  
  applyState();
  
  function updateAnimation() {
    if (isMobile() || isSmallMobile() || isExtraSmallMobile() || isTinyMobile() || isVeryTinyMobile() || isSuperTinyMobile()) {
      // Mobile: Only Phase 1
      const scrollY = window.scrollY;
      
      if (scrollY < 100) {
        setStartState();
        return;
      }
      
      const phase1End = 400;
      const startScroll = 100;
      let progress = (scrollY - startScroll) / (phase1End - startScroll);
      progress = Math.min(1, Math.max(0, progress));
      
      const eased = progress * progress * (3 - 2 * progress);
      
      const startTopVh = getStartTop();
      const endTopVh = getEndTop();
      const topVh = startTopVh + (endTopVh - startTopVh) * eased;
      const rotate = 25 + (0 - 25) * eased;
      const startWidth = getStartWidth();
      const endWidth = getEndWidth();
      const width = startWidth + (endWidth - startWidth) * eased;
      const startLeft = getStartLeft();
      const endLeft = getEndLeft();
      const left = startLeft + (endLeft - startLeft) * eased;
      
      image.style.top = topVh + 'vh';
      image.style.left = left + '%';
      image.style.width = width + '%';
      image.style.transform = 'translateX(-50%) rotate(' + rotate + 'deg)';
      return;
    }
    
    const scrollY = window.scrollY;
    
    if (scrollY < 100) {
      setStartState();
      return;
    }
    
    let phase1End, pauseStart, pauseEnd, phase3Start, phase3End;
    let phase1Top = getEndTop(); // Use the reduced end top for phase1
    let phase3Top = getEndTop();
    let endLeft = 31;
    let startTopVh = getStartTop();
    
    if (isExtraLarge2()) {
      phase1End = 750;
      pauseStart = 750;
      pauseEnd = 820;
      phase3Start = 820;
      phase3End = 950;
      phase1Top = 140; // 150 - 10
      phase3Top = 140;
      endLeft = 27;
      startTopVh = 25;
    } else if (isExtraLarge()) {
      phase1End = 750;
      pauseStart = 750;
      pauseEnd = 820;
      phase3Start = 820;
      phase3End = 950;
      phase1Top = 150; // 160 - 10
      phase3Top = 150;
      endLeft = 27;
      startTopVh = 25;
    } else if (isLargeDesktop()) {
      phase1End = 750;
      pauseStart = 750;
      pauseEnd = 820;
      phase3Start = 820;
      phase3End = 950;
      phase1Top = 160; // 170 - 10
      phase3Top = 160;
      endLeft = 27;
      startTopVh = 25;
    } else if (isMediumDesktop()) {
      phase1End = 730;
      pauseStart = 730;
      pauseEnd = 780;
      phase3Start = 780;
      phase3End = 920;
      phase1Top = 135; // 145 - 10
      phase3Top = 135;
      endLeft = 27;
      startTopVh = 25;
    } else if (isMediumLarge()) {
      phase1End = 700;
      pauseStart = 700;
      pauseEnd = 770;
      phase3Start = 770;
      phase3End = 900;
      phase1Top = 140; // 150 - 10
      phase3Top = 140;
      endLeft = 30;
      startTopVh = 27;
    } else if (isMediumSmall()) {
      phase1End = 500;
      pauseStart = 500;
      pauseEnd = 570;
      phase3Start = 570;
      phase3End = 700;
      phase1Top = 140; // 150 - 10
      phase3Top = 140;
      endLeft = 31;
      startTopVh = 29;
    } else {
      // Tablet (769-1024)
      phase1End = 450;
      pauseStart = 450;
      pauseEnd = 520;
      phase3Start = 520;
      phase3End = 650;
      phase1Top = 120; // 130 - 10
      phase3Top = 120;
      endLeft = 31;
      startTopVh = 31;
    }
    
    const startScroll = 100;
    let progress = (scrollY - startScroll) / (phase1End - startScroll);
    progress = Math.min(1, Math.max(0, progress));
    
    const eased = progress * progress * (3 - 2 * progress);
    
    const endTopVh = phase1Top;
    const topVh = startTopVh + (endTopVh - startTopVh) * eased;
    const rotate = 25 + (0 - 25) * eased;
    const widthPhase1 = 9 + (15 - 9) * eased;
    
    const isPaused = scrollY >= pauseStart && scrollY < pauseEnd;
    
    let phase3Progress = (scrollY - phase3Start) / (phase3End - phase3Start);
    phase3Progress = Math.min(1, Math.max(0, phase3Progress));
    const easedPhase3 = phase3Progress * phase3Progress * (3 - 2 * phase3Progress);
    
    const left = 44 + (endLeft - 44) * easedPhase3;
    const topPhase3 = phase1Top + (phase3Top - phase1Top) * easedPhase3;
    
    if (isPaused) {
      image.style.top = phase1Top + 'vh';
      image.style.left = '44%';
      image.style.width = '15%';
      image.style.transform = 'translateX(-50%) rotate(0deg)';
      return;
    }
    
    if (scrollY >= phase3Start) {
      image.style.top = topPhase3 + 'vh';
      image.style.left = left + '%';
      image.style.width = '15%';
      image.style.transform = 'translateX(-50%) rotate(0deg)';
      return;
    }
    
    image.style.top = topVh + 'vh';
    image.style.left = '44%';
    image.style.width = widthPhase1 + '%';
    image.style.transform = 'translateX(-50%) rotate(' + rotate + 'deg)';
  }
  
  window.addEventListener('scroll', updateAnimation);
  window.addEventListener('resize', function() {
    applyState();
    updateAnimation();
  });
  
  setTimeout(updateAnimation, 50);
});


document.addEventListener('DOMContentLoaded', function() {
  const headings = document.querySelectorAll('.hs_banner-heading h4');
  
  function wrapLetters() {
    headings.forEach((heading) => {
      const text = heading.textContent;
      heading.textContent = '';
      
      const chars = text.split('');
      
      chars.forEach((char) => {
        const span = document.createElement('span');
        span.className = 'letter';
        
        if (char === ' ') {
          span.innerHTML = '&nbsp;';
        } else {
          span.textContent = char;
        }
        
        heading.appendChild(span);
      });
    });
  }
  
  function animateLetters() {
    const headingWrappers = document.querySelectorAll('.hs_banner-heading');
    
    headingWrappers.forEach((wrapper) => {
      const letters = wrapper.querySelectorAll('.letter');
      if (!letters.length) return;
      
      const rect = wrapper.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight - 100 && rect.bottom > 0;
      
      if (isVisible) {
        letters.forEach((letter, index) => {
          setTimeout(() => {
            letter.classList.add('visible');
          }, index * 30);
        });
      } else {
        letters.forEach((letter) => {
          letter.classList.remove('visible');
        });
      }
    });
  }
  
  wrapLetters();
  
  window.addEventListener('scroll', function() {
    animateLetters();
  });
  
  setTimeout(animateLetters, 100);
});
// Banner ends
